import { theme } from '../theme/theme';

export const scrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.shades.disabled,
  },
};

export const filterScrollbarStyles = {
  marginRight: '8px',
  '&::-webkit-scrollbar': {
    width: '4px',
    height: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.shades.whiteBorder2,
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.shades.whiteBorder2,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.white.main,
  },
};

export const toastStyles = {
  success: {
    style: {
      // Background color
      background: theme.palette.success.light,
      color: theme.palette.success.main, // Text color
      borderRadius: 4,
      fontFamily: 'Satoshi',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 'normal',
      padding: '4px 6px',
    },
    iconTheme: {
      primary: theme.palette.success.light, // Icon background color
      secondary: theme.palette.success.main, // Icon color
    },
  },
  error: {
    style: {
      background: theme.palette.error.light,
      color: theme.palette.error.main, // Text color
      borderRadius: 4,
      fontFamily: 'Satoshi',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 'normal',
      padding: '4px 6px',
    },
    iconTheme: {
      primary: theme.palette.error.light, // Icon background color
      secondary: theme.palette.error.dark, // Icon color
    },
  },
};
